import { gql } from '@apollo/client'

export const COMPANIES_LIST_QUERY = gql`
  query COMPANIES_LIST_QUERY($filter: CompanyFilterInput, $pagination: PaginationInput!) {
    companies(filter: $filter, pagination: $pagination) {
      pagination {
        pageSkip
        pageTake
        totalCount
      }
      data {
        id
        name
      }
    }
  }
`

export const COMPANIES_SELECT_QUERY = gql`
  query COMPANIES_SELECT_QUERY($filter: CompanyFilterInput) {
    companies(filter: $filter) {
      data {
        id
        name
      }
    }
  }
`

export const COMPANY_DAYS_QUERY = gql`
  query COMPANY_DAYS_QUERY($filter: CompanyFilterInput) {
    companies(filter: $filter) {
      data {
        id
        businessDays
      }
    }
  }
`

export const COMPANY_DETAILS_QUERY = gql`
  query COMPANY_DETAILS_QUERY($filter: CompanyFilterInput) {
    companies(filter: $filter) {
      data {
        id
        name
        code
        domainName
        language
        address
        dateAndNumberFormat
        financialYearStartsAt
        financialYearFinishesAt
        sector
        timezone
        businessDays
        legitimateInterest
        privacyPolicy
        consentToCommunicate
        licences
        businessNumber
        companyNumber
        currency
        logoUrl
        refreshTokenAbsoluteTtl
        idleTimeoutSeconds
        twoFactorEnforced
      }
    }
  }
`

export const COMPANY_RISK_RESPONSE_TYPES_QUERY = gql`
  query COMPANY_RISK_RESPONSE_TYPES_QUERY {
    getCompanyRiskResponseTypes {
      responseTypesSets {
        id
        options {
          id
          active
          color
          label
          score
          value
        }
      }
    }
  }
`

export const COMPANY_RISK_RESPONSE_TYPES_PUBLIC_QUERY = gql`
  query COMPANY_RISK_RESPONSE_TYPES_PUBLIC_QUERY($domain: String!) {
    getCompanyRiskResponseTypesPublic(domain: $domain) {
      responseTypesSets {
        id
        options {
          id
          active
          color
          label
          score
          value
        }
      }
    }
  }
`

export const GET_COMPANY_PRIVACY_SETTINGS = gql`
  query getCompany {
    userMe {
      data {
        id
        company {
          id
          dataPrivacySettings {
            publicBusinessUnits
            publicLocations
            publicPositions
            publicResponseTypeOptions
            publicUsers
          }
        }
      }
    }
  }
`
